import { css, cva } from '@/styled-system/css';

export const cardContainerRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '168px',
    height: '100%',
    borderRadius: '200',
    border: '2px solid {colors.border.accent.brand.hero}',
  },
  variants: {
    isHovered: {
      true: { backgroundColor: 'bg.accent.blue.soft' },
      false: { backgroundColor: 'bg.neutral' },
    },
  },
});

export const cardAddressStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
});

export const myPropertyHeaderStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '246px',
});

export const myPropertyFactsContainerStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '113px',
  width: '100%',
});

export const myPropertyBannerStyles = css.raw({
  backgroundColor: 'bg.accent.brand.hero',
  color: 'text.onImpact.neutral',
  width: '100%',
  textAlign: 'center',
  borderRadius: '100',
});
